import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import icon from 'flarum/common/helpers/icon';

export default class DarkModeToggle extends Component {
    oninit(vnode) {
        super.oninit(vnode);
        this.isDarkMode = this.loadDarkModePreference();
        this.applyDarkMode(this.isDarkMode);
    }

    view() {
        return (
            <div className="DarkModeToggle">
                <Button
                    className="Button Button--icon Button--link"
                    onclick={() => this.toggleDarkMode()}
                    aria-label={app.translator.trans(
                        this.isDarkMode
                            ? 'zr-dark-mode-toggle.forum.toggle_light'
                            : 'zr-dark-mode-toggle.forum.toggle_dark'
                    )}
                    title={app.translator.trans(
                        this.isDarkMode
                            ? 'zr-dark-mode-toggle.forum.toggle_light'
                            : 'zr-dark-mode-toggle.forum.toggle_dark'
                    )}
                >
                    {icon(this.isDarkMode ? 'fas fa-sun' : 'fas fa-moon')}
                </Button>
            </div>
        );
    }

    toggleDarkMode() {
        this.isDarkMode = !this.isDarkMode;
        this.saveDarkModePreference(this.isDarkMode);
        this.applyDarkMode(this.isDarkMode);
        m.redraw();
    }

    loadDarkModePreference() {
        const stored = localStorage.getItem('zr-dark-mode');
        if (stored !== null) {
            return stored === 'true';
        }
        // Check for system preference
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    saveDarkModePreference(isDark) {
        localStorage.setItem('zr-dark-mode', isDark.toString());
    }

    applyDarkMode(isDark) {
        if (isDark) {
            document.body.classList.add('dark-mode');
            document.body.classList.remove('light-mode');
        } else {
            document.body.classList.remove('dark-mode');
            document.body.classList.add('light-mode');
        }
    }
}
